import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  Grid, Paper, Table, TableHead, Tooltip, Typography,
  TableRow, TableCell, TableBody, TableContainer
} from '@material-ui/core'

import AnnouncementIcon from '@material-ui/icons/Announcement'

import { withStyles } from '@material-ui/core/styles'

import {
  getSupervisorReport,
  setFromLink,
  getSupervisorUserReport
} from '../../../redux/actions'

import { setFilter, setReportsModal } from '../../../redux/actions/select'

import SupervisorUserList from '../modals/SupervisorUserList'

import { defaultFilter } from '../../../utils/variables'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

/**
 * Returns supervisor activity report
 */
const SupervisorActivityReport = (props) => {
  const {
    classes, page, rowsPerPage, supervisorActivityReport, fromLink,
    supervisorFilter
  } = props

  const dispatch = useDispatch()
  const View = useSelector(state => state.userSettings.general.defaultView)

  // const [page, setPage] = useState(0)
  // const [rowsPerPage, setRowsPerPage] = useState(25)
  const [supervisorName, setSupervisorName] = useState(null)
  const [actionType, setActionType] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [userNames, setUserNames] = useState([])

  // Get the report on component load
  useEffect(() => {
    (async () => {
      await dispatch(getSupervisorReport(supervisorFilter))
        .catch((err) => {
          console.error(err)
        })
    }
    )()
  }, [dispatch, supervisorFilter])

  // Handle the supervisor user report and corresponding modal view when a number is clicked
  const handleUserFilter = async (supervisorID, supervisorName, actionType) => {
  // Get filter for user-supervisor report modal
  // Get list of userNames from filter
    const users = await dispatch(getSupervisorUserReport({ supervisorID, actionType, startDate: supervisorFilter.startDate, endDate: supervisorFilter.endDate }))
      .catch((err) => { console.error(err); return false })
    // Pass in users with relevant data to the user modal
    if (!users) { return false }
    const names = Array.from(users)
    if (names && names.length) { setUserNames(names) }
    setSupervisorName(supervisorName)
    setActionType(actionType)
    setModalOpen(true)
  }

  // If a supervisor clicks on a username, set the filter to that and navigate back to view captures
  const navigateToUser = (user) => {
    const filter = { ...defaultFilter, usernames: [user] }
    dispatch(setFilter(filter))
    if (fromLink) {
      dispatch(setFromLink(false))
    }
    dispatch(setReportsModal(false))
    if (View === 'L') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (View === 'G') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
  }

  const toggleModal = () => {
    setModalOpen(false)
    setUserNames([])
    setActionType(null)
    setSupervisorName(null)
  }

  const truncateText = (str, length = 30) => {
    return str.length > 30 ? str.substring(0, length) + '...' : str
  }

  return (
    <>
      <SupervisorUserList
        supervisor={supervisorName}
        actionType={actionType}
        userNames={userNames}
        toggleModal={toggleModal}
        open={modalOpen}
        classes={classes}
        navigateToUser={navigateToUser}
      />

      <Grid container direction='column' justify='center' style={{ minWidth: '650px' }}>
        <Grid container direction='row'>
          <Grid container item direction='column' justify='flex-end' xs={12} style={{ overflowX: 'scroll' }} className={classes.tableContainer}>
            <Paper elevation={2} className={classes.tablePaper}>
              {/* <h5 style={{ marginTop: '1rem', marginLeft: '1rem', fontWeight: 'bold', color: '#0000008A', fontSize: '2rem' }}>Captures by Website</h5> */}
              {/* <h5
                style={{ marginTop: '1rem', marginLeft: '1rem', fontWeight: 'bold', color: '#0000008A', fontSize: '1rem' }}
              >
                Number Of Reported Websites: <span className='badge badge-primary my-auto mx-auto unselectable' style={{ fontSize: '1.3rem' }}>{totalProblems}</span>
              </h5> */}
              <Grid
                container
                direction='column'
                justify='center'
                className='px-3 w-100 py-3 mx-auto my-auto'
                spacing={2}
              >
                {
                  supervisorActivityReport && supervisorActivityReport !== null && supervisorActivityReport.length > 0
                    ? (
                      <>
                        <TableContainer>
                          <Table className={classes.table} size='small' aria-label='users-table'>
                            <TableHead>
                              <TableRow>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`}>Supervisor</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Problem</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Not A Problem</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Hold</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Resolved</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Quarantined</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Viewed</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Shared</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Flagged</TableCell>
                                <TableCell size='small' className={`${classes.tableHeadText} unselectable`} align='right'>Comments</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {supervisorActivityReport.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((supervisor, index) => (
                                <StyledTableRow key={index}>
                                  {/* SUPERVISOR NAME */}
                                  <TableCell
                                    size='small'
                                    className={`${classes.tableText} unselectable`}
                                    component='th'
                                    scope='row'
                                  >
                                    {
                                      (supervisor.firstName + ' ' + supervisor.lastName).length > 30
                                        ? (
                                          <LightTooltip title={supervisor.firstName + ' ' + supervisor.lastName} placement='top-end' arrow>
                                            <Typography className={classes.tableText}>{truncateText(supervisor.firstName + ' ' + supervisor.lastName)}</Typography>
                                          </LightTooltip>

                                        )
                                        : (
                                          <Typography className={classes.tableText}>{supervisor.firstName + ' ' + supervisor.lastName}</Typography>
                                        )
                                    }
                                  </TableCell>
                                  {/* PROBLEM ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'problem_captures')
                                    }}
                                  >
                                    {supervisor.problem_captures || 0}
                                  </TableCell>
                                  {/* NOT A PROBLEM ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'not_a_problem_captures')
                                    }}
                                  >
                                    {supervisor.not_a_problem_captures || 0}
                                  </TableCell>
                                  {/* HELD ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'held_captures')
                                    }}
                                  >
                                    {supervisor.held_captures || 0}
                                  </TableCell>
                                  {/* RESOLVED ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'resolved_captures')
                                    }}
                                  >
                                    {supervisor.resolved_captures || 0}
                                  </TableCell>
                                  {/* QUARANTINED ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'quarantined_captures')
                                    }}
                                  >
                                    {supervisor.quarantined_captures || 0}
                                  </TableCell>
                                  {/* VIEWED ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'viewed_captures')
                                    }}
                                  >
                                    {supervisor.viewed_captures || 0}
                                  </TableCell>
                                  {/* SHARED ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'shared_captures')
                                    }}
                                  >
                                    {supervisor.shared_captures || 0}
                                  </TableCell>
                                  {/* FLAGGED ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'flagged_captures')
                                    }}
                                  >
                                    {supervisor.flagged_captures || 0}
                                  </TableCell>
                                  {/* COMMENT ACTION COUNT */}
                                  <TableCell
                                    size='small'
                                    align='right'
                                    className={`${classes.tableText} unselectable`}
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                      e.preventDefault(); handleUserFilter(supervisor.supervisorID, supervisor.firstName + ' ' + supervisor.lastName, 'capture_comments')
                                    }}
                                  >
                                    {supervisor.capture_comments || 0}
                                  </TableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    )
                    : (
                      <>
                        <Grid item container direction='row' justify='center' alignItems='center'>
                          {/* <Loader type='ThreeDots' color='#97b557' height={150} width={150} /> */}
                          <Paper
                            className='mx-auto'
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginTop: '10vh',
                              height: '20rem',
                              width: '35rem',
                              padding: '1.5rem',
                              backgroundColor: '#F5F5F5'
                            }}
                          >
                            <Grid item container direction='column' xs={12}>
                              <Grid item container direction='row' justify='center'>
                                <AnnouncementIcon
                                  style={{
                                    fontSize: '4rem',
                                    color: 'grey',
                                    marginBottom: '1rem'
                                  }}
                                />
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography
                                  style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.5rem' }}
                                >
                                  No Actions Found
                                </Typography>
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography>There are currently no supervisor actions for your account. Please allow your supervisors time to take actions then try again.</Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </>
                    )
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default withRouter(SupervisorActivityReport)
